module.exports = __webpack_public_path__ + "static/media/blush-index.b7e71acc.jpg";